const UNDEFINED = 'undefined';
export function isSSR() {
  return typeof window === UNDEFINED || typeof document === UNDEFINED;
}
